import { getLocalizedAttrValue } from "@grandvisionhq/utils";
import { getAttribute } from "../../../../../../../../../../utils/utils/get-line-item-attribute.js";
import { getLineItemDiscount } from "../../../../../../../../../../utils/utils/get-line-item-discount.js";
import { getLineItemPrice } from "../../../../../../../../../../utils/utils/get-line-item-price.js";
import { getLocalizedString } from "../../../../../../../../../../utils/utils/get-localized-string.js";
import { getBundledLineItemProductVariant } from "../../../../../../bundles/mappers/view/line-item/utils/bundles/get-bundled-line-item-product-variant.js";
function getBundledProductInfo(bundleLineItem, intl) {
  const { name } = bundleLineItem.legacyProduct.masterData.current;
  const variant = getBundledLineItemProductVariant(bundleLineItem);
  const variationAttribute = getAttribute(variant, "variationAttribute");
  const variationAttributeValue = getLocalizedAttrValue(variant, variationAttribute, intl.locale);
  const bundleTitle = getLocalizedString(intl.locale, name);
  return {
    sku: variant.sku,
    name: bundleTitle,
    title: !!variationAttributeValue ? `${bundleTitle} - ${variationAttributeValue}` : bundleTitle,
    ...bundleLineItem.price ? {
      price: getLineItemPrice(bundleLineItem.price, intl.locale).unit,
      discount: bundleLineItem.discounts ? getLineItemDiscount(bundleLineItem.price, intl.locale, bundleLineItem.discounts) : void 0
    } : {}
  };
}
export {
  getBundledProductInfo
};
//# sourceMappingURL=get-bundled-product-info.js.map
